import { snackbar } from "@mobiscroll/react5";
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { ReactNotifications } from "react-notifications-component";
import HeaderTop from "./HeaderTop";
import IdleTimer from "./IdleTimer";
import LeftSidebar from "./LeftSidebar";
import { signOut } from "aws-amplify/auth";

import { useSelector } from "react-redux";
import Subscription from "src/components/Dashboard/Subscription/Subscription";
import { isBeforeDate } from "src/lib/dateUtils";
import BetaVersion from "./betaVersion";
import { useLocation, useRouteMatch } from "react-router-dom";
import { useDoctorSubscriptions } from "src/lib/hooks/useDoctorSubscriptions";

const DoctorTemplate = (props) => {
  const [isSideBarVisible, setIsSideBarVisible] = useState(window.innerWidth > 1200);
  const [searchBar, setSearchBar] = useState(true);
  const [TimeBar, setTimeBar] = useState(true);
  const [show, setShow] = useState(false);

  const location = useLocation();

  const user = useSelector((state) => state.user.user);
  const trialExpiry = user?.freeUntilTimestamp;
  const isTrialActive = trialExpiry ? isBeforeDate(trialExpiry) : false;

  const doctorId = user?.id || sessionStorage.getItem("role-id");
  useDoctorSubscriptions(doctorId);

  // Check if current path is open-patient-app
  const isOpenPatientApp = useRouteMatch({ path: "/open-patient-app/:clinicId", exact: true, strict: false });
  const isVideoNotes = useRouteMatch({ path: "/video-notes/:patientId", exact: false, strict: false, });
  const isSubscribing = useRouteMatch({ path: "/subscription", exact: false, strict: false });

  React.useEffect(() => {
    let prompt = sessionStorage.getItem("showPrompt");
    if (prompt) {
      setShow(true);
    }
    sessionStorage.removeItem("showPrompt");
  }, []);

  const onClose = () => setShow(false);

  const doctorSignout = async () => {
    try {
      await signOut()
      snackbar({ message: "You have been logged out", color: "danger", });
      localStorage.clear();
      sessionStorage.clear();
      window.location.href = "/";
    }
    catch (error) {
      snackbar({ message: "Unable to logout, Please Refresh.", color: "danger" });
      console.error("error signing out: ", error);
    }
  }

  useEffect(() => {
    const timer = new IdleTimer({
      timeout: 15 * 60, //expire after 15 mins
      onTimeout: async () => {
        await doctorSignout();
      },
      onExpired: async () => {
        await doctorSignout();
      },
    });

    return () => {
      timer.cleanUp();
    };
  }, []);

  const handleSidebar = () => {
    setIsSideBarVisible((prev) => !prev);
  };

  // Check if user should be allowed to bypass subscription check
  const shouldBypassSubscription = isOpenPatientApp || isVideoNotes || isSubscribing;

  // Show subscription page if user is not authenticated AND not trying to access open-patient-app
  if (user &&
    !isTrialActive &&
    !["active", "authenticated"].includes(user.subscriptionStatus) &&
    !shouldBypassSubscription
  ) {
    return (
      <>
        <HeaderTop
          handleSidebar={handleSidebar}
          searchBar={searchBar}
          TimeBar={TimeBar}
        />
        <Subscription />
      </>
    )
  }

  return (
    <>
      <div className="wrapper">
        {!isVideoNotes && !isSubscribing && (
          <Modal
            show={show}
            onHide={onClose}
            backdrop="static"
            keyboard={false}
            dialogClassName="docg-modal"
            size="lg"
            centered
          >
            <BetaVersion onClose={onClose} />
          </Modal>
        )}

        <LeftSidebar
          handleSidebar={handleSidebar}
          isSideBarVisible={isSideBarVisible}
          setIsSideBarVisible={setIsSideBarVisible}
        />

        <ReactNotifications />

        <div className={`main-panel${isSideBarVisible ? "" : " min-sidebar"}`}>
          <HeaderTop
            handleSidebar={handleSidebar}
            searchBar={searchBar}
            TimeBar={TimeBar}
          />
          <div className="content">
            <div className="mbsc-grid">
              <div className="mbsc-row">{props.children}</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DoctorTemplate;